import {Box, Link, styled, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AccessTimeRounded, CalendarTodayRounded} from "@mui/icons-material";
import React from "react";
import Carousel from "react-material-ui-carousel";

const Container = styled(Box)(() => ({
  backgroundSize: 'cover',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '80px 20px',
  position: 'relative',
}));

const StyledBox = styled(Box)(({theme}) => ({
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

const ImageContainer = styled(Box)(({theme}) => ({
  maxHeight: 460,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    minWidth: 420,
  },
}));

const Image = styled('img')(() => ({
  maxWidth: '100%',
  maxHeight: 'inherit',
  borderRadius: '8px',
}));

const Title = styled(Typography)(() => ({
  fontWeight: 600,
  textTransform: 'uppercase',
}));

const EventSection = () => {
  const {t} = useTranslation();

  return (
    <>
      <Title variant="h4" textAlign="center">{t('expired-events.title')}</Title>
      <Container >
        <StyledBox width={1200} display="flex" flexDirection="row-reverse">
          <Box sx={{ p: 4, width: '100%' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded />
              <Title variant="subtitle1">{t('event7.title')}</Title>
            </Box>
            <Box sx={{ mb: 4, mt: 1, color: '#9a9a9a' }} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded />
              <Title variant="caption">{t('event7.time')}</Title>
            </Box>
            <Typography variant="body">{t('event7.description')}</Typography>
          </Box>
          <ImageContainer>
            <Carousel
                sx={{ width: 450, height: '100%'}}
                next={(next, active) => console.log(`we left ${active}, and are now at ${next}`)}
                prev={(prev, active) => console.log(`we left ${active}, and are now at ${prev}`)}
            >
              <Image src="/img/photo_5285086867416092959_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5285086867416092960_y.jpg" alt="event_image"/>
            </Carousel>
          </ImageContainer>
        </StyledBox>
      </Container>
      <Container paddingY={0}>
        <StyledBox width={1200} display="flex" flexDirection="row-reverse">
          <ImageContainer>
            <Carousel
                sx={{ width: 450, height: '100%'}}
                next={(next, active) => console.log(`we left ${active}, and are now at ${next}`)}
                prev={(prev, active) => console.log(`we left ${active}, and are now at ${prev}`)}
            >
              <Image src="/img/photo_5276262376070123397_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5276262376070123398_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5276262376070123399_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5276262376070123400_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5276262376070123401_y.jpg" alt="event_image"/>
            </Carousel>
          </ImageContainer>
          <Box sx={{ p: 4, width: '100%' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded />
              <Title variant="subtitle1">{t('event6.title')}</Title>
            </Box>
            <Box sx={{ mb: 4, mt: 1, color: '#9a9a9a' }} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded />
              <Title variant="caption">{t('event6.time')}</Title>
            </Box>
            <Typography variant="body">{t('event6.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container paddingY={0}>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Image src="/img/literarisher-abend.jpg" alt="event_image" />
          </ImageContainer>
          <Box sx={{ p: 4, width: '100%' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded />
              <Title variant="subtitle1">{t('event1.title')}</Title>
            </Box>
            <Box sx={{ mb: 4, mt: 1, color: '#9a9a9a' }} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded />
              <Title variant="caption">{t('event1.time')}</Title>
            </Box>
            <Typography variant="h5">{t('event1.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container paddingY={0}>
        <StyledBox width={1200} display="flex" flexDirection="row-reverse">
          <ImageContainer>
            <Image src="/img/seminar.jpg" alt="event_image" />
          </ImageContainer>
          <Box sx={{ p: 4, width: '100%' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded />
              <Title variant="subtitle1">{t('event2.title')}</Title>
            </Box>
            <Box sx={{ mb: 4, mt: 1, color: '#9a9a9a' }} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded />
              <Title variant="caption">{t('event2.time')}</Title>
            </Box>
            <Typography variant="h5">{t('event2.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container paddingY={0}>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Image src="/img/photo_5242737532096083706_y.jpg" alt="event_image" />
          </ImageContainer>
          <Box sx={{ p: 4, width: '100%' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded />
              <Title variant="subtitle1">{t('event3.title')}</Title>
            </Box>
            <Box sx={{ mb: 4, mt: 1, color: '#9a9a9a' }} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded />
              <Title variant="caption">{t('event3.time')}</Title>
            </Box>
            <Typography variant="h5">{t('event3.description1')}</Typography>
            <br />
            <Typography variant="h6">{t('event3.description2')}</Typography>
            <br />
            <Link href="https://gofund.me/3d8f8b4a" target="_blank">https://gofund.me/3d8f8b4a</Link>
          </Box>
        </StyledBox>
      </Container>
      <Container paddingY={0}>
        <StyledBox width={1200} display="flex" flexDirection="row-reverse">
          <ImageContainer>
            <Image src="/img/photo_5267263006537017311_y.jpg" alt="event_image" />
          </ImageContainer>
          <Box sx={{ p: 4, width: '100%' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded />
              <Title variant="subtitle1">{t('event4.title')}</Title>
            </Box>
            <Box sx={{ mb: 4, mt: 1, color: '#9a9a9a' }} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded />
              <Title variant="caption">{t('event4.time')}</Title>
            </Box>
            <Typography variant="h5">{t('event4.description1')}</Typography>
            <br />
            <Typography variant="h6">{t('event4.description2')} <Link href="https://form.jotform.com/250072543732047" target="_blank">{t('event4.link')}</Link></Typography>
            <br />
          </Box>
        </StyledBox>
      </Container>
    </>
  );
};

export default EventSection;
